import _defineProperty from "/home/wspadmin/Dev-Agent4/_work/2/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_OPTIONS = {
  styles: "\n*:focus {\n    outline: none !important;\n}\n*::-moz-focus-inner {\n    border: none !important;\n}",
  stylesheetTarget: typeof document !== 'undefined' && document.head
};
var ACCEPTED_KEYS = [9,
// Tab
37,
// ArrowLeft
38,
// ArrowTop
39,
// ArrowRight
40 // ArrowDown
];
var createStylesheet = function createStylesheet(options) {
  var styleNode = document.createElement('style');
  var targetNode = options.stylesheetTarget;
  styleNode.innerText = options.styles;
  return {
    apply: function apply() {
      targetNode.append(styleNode);
    },
    unapply: function unapply() {
      if (styleNode.parentNode === targetNode) {
        targetNode.removeChild(styleNode);
      }
    }
  };
};
var createListeners = function createListeners(styleSheet) {
  var usingKeyboard = false;
  var handleKeydown = function handleKeydown(ev) {
    if (!usingKeyboard && ACCEPTED_KEYS.includes(ev.keyCode)) {
      usingKeyboard = true;
    }
  };
  var handleMousedown = function handleMousedown() {
    usingKeyboard = false;
  };
  var handleFocusin = function handleFocusin() {
    if (!usingKeyboard) {
      styleSheet.apply();
    } else {
      styleSheet.unapply();
    }
  };
  document.addEventListener('keydown', handleKeydown);
  document.addEventListener('mousedown', handleMousedown);
  document.addEventListener('focusin', handleFocusin); // Trigger the focus handler if there's a focused element

  if (document.activeElement && document.activeElement.tagName !== 'BODY' && document.activeElement.tagName !== 'HTML') {
    handleFocusin();
  }
  return function () {
    document.removeEventListener('keydown', handleKeydown);
    document.removeEventListener('mousedown', handleMousedown);
    document.removeEventListener('focusin', handleFocusin);
  };
};
var keyboardOnlyOutlines = function keyboardOnlyOutlines(options) {
  options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  var stylesheet = createStylesheet(options);
  var destroyListeners = createListeners(stylesheet);
  return function () {
    stylesheet.unapply();
    destroyListeners();
  };
};
export default keyboardOnlyOutlines;